import { createContext } from 'react';

/** Evaluation tools never write learner evidence, even with an existing student session. */
export const StudyToolEvaluationContext = createContext(false);
